<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="widgets__background module__background"
        ></app-modulebackground>
        <div
            class="widgets__container module__container"
            v-bind:class="{
                container__boxed: [1].includes(module.layout.type),
                'container__boxed--half': [2].includes(module.layout.type)
            }"
        >
            <div class="widgets__inner module__inner">
                <div class="widgets__inner--main module__inner--main">
                    <div class="widgets__inner-row module__inner-row">
                        <div class="widgets__inner-col module__inner-col">
                            <div class="widgets__content-block module__content-block">
                                <div
                                    class="widgets__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2].includes(module.layout.type)
                                    }"
                                >
                                    <div class="widgets__header module__header">
                                        <h2
                                            class="widgets__title module__title font-h2 color-h2"
                                            v-if="module.data.title"
                                            v-html="module.data.title"
                                        ></h2>
                                    </div>
                                </div>
                                <div
                                    class="widgets__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2].includes(module.layout.type)
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="widgets__inner-row module__inner-row">
                                        <div class="widgets__inner-col module__inner-col">
                                            <div
                                                ref="slider"
                                                per-page="1"
                                                per-page-lg="1"
                                                per-page-md="1"
                                                per-page-sm="1"
                                                class=""
                                                v-bind:class="{
                                                    slider:
                                                        [2].includes(module.layout.type) &&
                                                        items.length > 1
                                                }"
                                            >
                                                <ul class="widget__list module__list">
                                                    <li
                                                        v-for="items__value in items"
                                                        v-bind:key="items__value.id"
                                                        :data-preset-id="items__value.preset_id"
                                                        class="widget__list-item module__list-item"
                                                    >
                                                        <a
                                                            v-if="
                                                                [1, 2].includes(
                                                                    module.layout.type
                                                                ) &&
                                                                    items__value.data &&
                                                                    items__value.data.url &&
                                                                    items__value.data.type ===
                                                                        'link'
                                                            "
                                                            :href="items__value.data.url"
                                                            target="_blank"
                                                            class="widget__list-item-link"
                                                        >
                                                            <img
                                                                v-if="
                                                                    items__value.data &&
                                                                        items__value.data.image
                                                                "
                                                                v-bind:src="
                                                                    generateMediaUrl({
                                                                        path:
                                                                            items__value.data.image
                                                                    })
                                                                "
                                                                v-bind:alt="
                                                                    items__value.data.name
                                                                        ? items__value.data.name
                                                                        : ''
                                                                "
                                                                class="widget__list-item-image"
                                                            />
                                                        </a>
                                                        <div
                                                            v-if="
                                                                [1, 2].includes(
                                                                    module.layout.type
                                                                ) &&
                                                                    items__value.data &&
                                                                    items__value.data.type ===
                                                                        'wsh_id'
                                                            "
                                                            :data-id="items__value.data.id"
                                                            class="wsh__container"
                                                        ></div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import { SliderMixin } from '@/mixins/SliderMixin';
import Widgets from '@/external/modules/Widgets';

export default {
    data() {
        return {};
    },
    mixins: [SliderMixin],
    components: {
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getListItems', 'generateMediaUrl', 'editorMode']),
        items() {
            return this.getListItems('deha.user.misc.widgets');
        }
    },
    props: {
        module: Object
    },
    mounted() {
        if (this.editorMode) {
            let i = new Widgets();
            i.init(this.$refs.root);
        }
    },
    updated() {
        if (this.editorMode) {
            let i = new Widgets();
            i.init(this.$refs.root);
        }
    }
};
</script>
